import React from 'react';

import { SVGPropsType } from 'src/types';

function ChartSetting(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14 10.6666V5.33331C14 4.86665 13.7333 4.39998 13.3333 4.19998L8.66667 1.53331C8.26667 1.26665 7.73333 1.26665 7.33333 1.53331L2.66667 4.19998C2.26667 4.39998 2 4.86665 2 5.33331V10.6666C2 11.1333 2.26667 11.6 2.66667 11.8L7.33333 14.4666C7.73333 14.7333 8.26667 14.7333 8.66667 14.4666L13.3333 11.8C13.7333 11.6 14 11.1333 14 10.6666Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ChartSetting;
